import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect } from '../../../adapter-vue';
import { isWeChat } from '../../../utils/env';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  show: {
    type: Boolean,
    default: () => false,
  },
},
  emits: ['update:show'],
  setup(__props, { emit }) {

const props = __props



const showMask = ref(false);

watchEffect(() => {
  showMask.value = props.show;
});



const toggleView = () => {
  showMask.value = !showMask.value;
  emit('update:show', showMask.value);
};


return { __sfc: true,props, showMask, emit, toggleView, isWeChat }
}

})